import { render } from "./dt-dash.vue?vue&type=template&id=12e0e48c&scoped=true"
import script from "./dt-dash.vue?vue&type=script&lang=js"
export * from "./dt-dash.vue?vue&type=script&lang=js"

import "./dt-dash.vue?vue&type=style&index=0&id=12e0e48c&lang=scss"
import "./dt-dash.vue?vue&type=style&index=1&id=12e0e48c&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e0e48c"]])

export default __exports__